var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#HeartFilled_svg__clip0_1238_432104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.979 3.07401C7.86407 2.92321 8.77169 2.97296 9.63497 3.21958C10.4982 3.46621 11.2952 3.90343 11.967 4.49901L12.004 4.53201L12.038 4.50201C12.6792 3.93931 13.433 3.51981 14.2492 3.27149C15.0653 3.02318 15.9251 2.95177 16.771 3.06201L17.017 3.09801C18.0833 3.28212 19.08 3.75117 19.9015 4.45548C20.723 5.1598 21.3387 6.07316 21.6835 7.09885C22.0282 8.12454 22.0892 9.22437 21.8599 10.2819C21.6306 11.3394 21.1196 12.3152 20.381 13.106L20.201 13.291L20.153 13.332L12.703 20.711C12.5311 20.8812 12.3033 20.9832 12.0619 20.9983C11.8205 21.0134 11.5818 20.9405 11.39 20.793L11.296 20.711L3.803 13.289C3.00922 12.5167 2.4447 11.5397 2.17196 10.4663C1.89922 9.39287 1.92891 8.26491 2.25772 7.20733C2.58654 6.14974 3.20166 5.20381 4.03497 4.47428C4.86827 3.74476 5.88723 3.26011 6.979 3.07401Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "HeartFilled_svg__clip0_1238_432104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
export default SvgHeartFilled;